import { postForm } from '../shared/api/client';
import { hide, show } from '../shared/ui/dom';

type AuthResponse = { success?: boolean; error?: string };

function setMessage(id: string, text: string): void {
  const el = document.getElementById(id);
  if (!el) return;
  el.textContent = text;
  show(el);
}

async function init(): Promise<void> {
  const form = document.getElementById('register-form') as HTMLFormElement | null;
  const btn = document.getElementById('register-btn') as HTMLButtonElement | null;
  const errorEl = document.getElementById('auth-error');
  const successEl = document.getElementById('auth-success');
  if (!form || !btn || !errorEl || !successEl) return;

  form.addEventListener('submit', async event => {
    event.preventDefault();
    hide(errorEl);
    hide(successEl);

    const password = (document.getElementById('password') as HTMLInputElement | null)?.value || '';
    const confirm = (document.getElementById('confirm') as HTMLInputElement | null)?.value || '';

    if (password.length < 6) {
      setMessage('auth-error', 'Le mot de passe doit faire au moins 6 caractères');
      return;
    }

    if (password !== confirm) {
      setMessage('auth-error', 'Les mots de passe ne correspondent pas');
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Création…';

    try {
      const body = new FormData(form);
      const data = await postForm<AuthResponse>('api/auth/register.php', body);
      if (data.success) {
        window.location.href = './';
        return;
      }
      setMessage('auth-error', data.error || 'Erreur lors de la création du compte');
    } catch (error) {
      setMessage('auth-error', error instanceof Error ? error.message : 'Erreur réseau');
    } finally {
      btn.disabled = false;
      btn.textContent = 'Créer le compte';
    }
  });
}

void init();
